import { frameKindOf } from './frameKind';
import { ContainDefault } from './Container/ContainDefault';
import { FC } from 'react';
import { IQuestionModel } from '../../../state/stores/Question/QuestionModel';
import { PresentDefault } from './Presentation/PresentDefault';
import { QuestionSessionBodyProps, config } from './config';
import { SnapshotOut } from 'mobx-state-tree';
import { observer } from 'mobx-react';

const getConfig = (question: SnapshotOut<IQuestionModel>) => {
  const kind = frameKindOf(question) || question.key;
  const byKind = kind ? config[kind as keyof typeof config] : undefined;
  // a question without a frame kind or key can still be drawn by its type
  // (an instruction is a static frame, not a question to answer)
  return byKind || (question.type ? config[question.type as keyof typeof config] : undefined);
};

const QuestionSessionBody: FC<QuestionSessionBodyProps> = ({
  question,
  margin,
}) => {
  const questionSessionBodyConfig = getConfig(question);
  const Container = questionSessionBodyConfig?.Container || ContainDefault;
  const Presentation = questionSessionBodyConfig?.Presentation || PresentDefault;
  return (
    <Container
      question={question}
    >
      {state => (
        <Presentation
          margin={margin}
          questionId={state.questionId}
          questionKey={state.questionKey}
          questionType={state.questionType}
          questionText={state.questionText}
          questionDescription={state.questionDescription}
          questionImage={state.questionImage}
          meta={state.meta}
          loading={state.loading}
          data={state.data}
        />
      )}
    </Container>
  );
};
export default observer(QuestionSessionBody);
